var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 48,
    viewBox: "0 0 58 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3636 10.6667H40.4234V2.66667C40.4234 1.95942 40.1456 1.28115 39.6512 0.781048C39.1568 0.280951 38.4862 0 37.787 0H20.213C19.5138 0 18.8432 0.280951 18.3488 0.781048C17.8544 1.28115 17.5766 1.95942 17.5766 2.66667V21.3333H2.63636C1.93716 21.3333 1.26659 21.6143 0.772173 22.1144C0.277759 22.6145 0 23.2928 0 24V45.3333C0 46.0406 0.277759 46.7189 0.772173 47.219C1.26659 47.7191 1.93716 48 2.63636 48H55.3636C56.0628 48 56.7334 47.7191 57.2278 47.219C57.7222 46.7189 58 46.0406 58 45.3333V13.3333C58 12.6261 57.7222 11.9478 57.2278 11.4477C56.7334 10.9476 56.0628 10.6667 55.3636 10.6667ZM17.5766 42.6667H5.27273V26.6667H17.5766V42.6667ZM35.1506 42.6667H22.8494V5.33333H35.1506V42.6667ZM52.7273 42.6667H40.4234V16H52.7273V42.6667Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/Level.075076f70c351189d0a32c9ffac3cd07.svg";
export { ForwardRef as ReactComponent };